// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"_1eMAEQ6tAU1x","chip":"_1u_voUjWOJ5G"};